import { MenuClassification } from 'features/MenuList/models/menu';
import { CommonResponse, TargetMenu } from 'models';
import axiosClient from 'utils/axiosClient';
import { SearchTargetMenuPayoad } from './types';

const targetMenuService = {
  getMenus(payload: SearchTargetMenuPayoad): Promise<CommonResponse<TargetMenu[]>> {
    let url = `/target-menus`;
    return axiosClient.post(url, payload);
  },
  getMenuClassification(): Promise<CommonResponse<MenuClassification[]>> {
    const url = `/menu-classification`;
    return axiosClient.get(url);
  },
};

export default targetMenuService;
